/**
 * Features intentionally held outside the public beta until their server-side
 * authority is complete. These gates are UX only; the SQL migration revokes
 * the matching mutation RPCs as the actual security boundary.
 */
export const RELEASE_FEATURES = Object.freeze({
  raids: false,
  clans: false,
  dailyQuestRewards: true,
  seasonPass: true,
  paidEmeralds: false,
  miner: false,
});

export function unavailableFeatureMessage(feature) {
  const label = {
    raids: 'Raids',
    clans: 'Clãs',
    dailyQuestRewards: 'Missões diárias',
    seasonPass: 'Game Pass',
    paidEmeralds: 'Compras de Esmeraldas',
    miner: 'Mineração',
  }[feature] || 'Este sistema';
  return `${label} ainda não fazem parte deste beta.`;
}
